"use client";

import { c as _c } from "react/compiler-runtime";
import { isPlacementStatusQuery } from "@/utils/placement/query-state";
import { trpc } from "@/utils/trpc.client";
import { getTrpcHttpTransport } from "@/utils/trpc/client-transport";
import { fetchGeneratedListTrpcRequest } from "@/utils/trpc/generated-list-route.client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchStreamLink, httpLink, httpSubscriptionLink, loggerLink, splitLink } from "@trpc/client";
import { useState } from "react";
import superjson from "superjson";
export function TRPCProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp2);
  const [trpcClient] = useState(_temp8);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryClient || $[4] !== t1 || $[5] !== trpcClient) {
    t2 = <trpc.Provider client={trpcClient} queryClient={queryClient}>{t1}</trpc.Provider>;
    $[3] = queryClient;
    $[4] = t1;
    $[5] = trpcClient;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp8() {
  return trpc.createClient({
    links: [loggerLink({
      enabled: _temp3
    }), splitLink({
      condition: _temp4,
      true: httpSubscriptionLink({
        url: "/api/trpc",
        transformer: superjson
      }),
      false: splitLink({
        condition: _temp5,
        true: httpLink({
          url: "/api/trpc-search",
          transformer: superjson
        }),
        false: splitLink({
          condition: _temp6,
          true: httpLink({
            fetch: fetchGeneratedListTrpcRequest,
            url: "/api/trpc-list",
            transformer: superjson
          }),
          false: splitLink({
            condition: _temp7,
            true: httpLink({
              url: "/api/trpc",
              transformer: superjson
            }),
            false: httpBatchStreamLink({
              url: "/api/trpc",
              transformer: superjson
            })
          })
        })
      })
    })]
  });
}
function _temp7(op_2) {
  return getTrpcHttpTransport({
    context: op_2.context,
    path: op_2.path
  }) === "direct";
}
function _temp6(op_1) {
  return getTrpcHttpTransport({
    context: op_1.context,
    path: op_1.path
  }) === "generated-list";
}
function _temp5(op_0) {
  return getTrpcHttpTransport({
    context: op_0.context,
    path: op_0.path
  }) === "search";
}
function _temp4(op) {
  return op.type === "subscription";
}
function _temp3(options) {
  return process.env.NODE_ENV === "development" && "path" in options && options.path !== "finance.updateExternalPayee";
}
function _temp2() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        staleTime: _temp
      }
    }
  });
}
function _temp(query) {
  return isPlacementStatusQuery(query.queryKey) ? 0 : 30000;
}